import React from "react";
import "./styles/RegisterForm.css";
import { connect } from "react-redux";
import * as actions from "../redux/actions/countryActions";
import { Link } from "react-router-dom";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import { Translate, I18n } from "react-redux-i18n";
import { withRouter } from "react-router";
import {
  FaEnvelope,
  FaEye,
  FaEyeSlash,
  FaLock,
  FaUserPlus,
} from "react-icons/fa";
import MiniLoader from "./MiniLoader";
import CountrySelect from "./CountrySelect";

class RegisterForm extends React.Component {
  state = {
    showPassword: false,
    showPassword2: false,
  };

  componentDidMount() {
    this.fetchCountry();
  }

  fetchCountry = async () => {
    try {
      await this.props.LoadCountry().then(() => {
        if (this.props.error_country) {
          alertify.warning(I18n.t(this.props.error_country));
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  togglePassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  togglePassword2 = () => {
    this.setState({ showPassword2: !this.state.showPassword2 });
  };

  renderField = ({
    id,
    name,
    type = "text",
    labelKey,
    placeholderKey,
    icon: Icon,
    hasError,
    value,
    showToggle,
    showValue,
    onToggle,
  }) => (
    <div className="register-form__field">
      <label className="register-form__label" htmlFor={id}>
        <Translate value={labelKey} />
      </label>
      <div
        className={`register-form__input-wrap${
          hasError ? " register-form__input-wrap--invalid" : ""
        }`}
      >
        {Icon && (
          <span className="register-form__input-icon" aria-hidden="true">
            <Icon />
          </span>
        )}
        <input
          id={id}
          type={type}
          name={name}
          className="register-form__input"
          placeholder={I18n.t(placeholderKey)}
          value={value || ""}
          onChange={this.props.onChange}
          autoComplete="new-password"
          required
        />
        {showToggle && (
          <button
            type="button"
            className="register-form__toggle"
            onClick={onToggle}
            aria-label="Toggle password visibility"
          >
            {showValue ? <FaEyeSlash /> : <FaEye />}
          </button>
        )}
      </div>
    </div>
  );

  render() {
    const {
      form,
      error,
      passwordErrorKey,
      password2ErrorKey,
      accept_tos,
      onChangeAcceptTos,
      onClickRegister,
      submitting,
    } = this.props;

    return (
      <div className="register-card">
        <div className="register-card__icon" aria-hidden="true">
          <FaUserPlus />
        </div>

        <header className="register-card__header">
          <h1 className="register-card__title">
            <Translate value="register" />
          </h1>
          <p className="register-card__subtitle">
            <Translate value="register_tip1" />
          </p>
        </header>

        <form className="register-form" onSubmit={onClickRegister} noValidate>
          {this.renderField({
            id: "register_email",
            name: "email",
            type: "email",
            labelKey: "profile_email",
            placeholderKey: "email",
            icon: FaEnvelope,
            hasError: error.email,
            value: form.email,
          })}
          {error.email && (
            <p className="register-form__error">
              <Translate value="warning_email_valid" />
            </p>
          )}

          {this.renderField({
            id: "register_password",
            name: "password",
            type: this.state.showPassword ? "text" : "password",
            labelKey: "password",
            placeholderKey: "password",
            icon: FaLock,
            hasError: error.password,
            value: form.password,
            showToggle: true,
            showValue: this.state.showPassword,
            onToggle: this.togglePassword,
          })}
          <p className="register-form__hint">
            <Translate value="password_tip" />
          </p>
          {error.password && (
            <p className="register-form__error">
              <Translate value={passwordErrorKey || "warning_password_weak"} />
            </p>
          )}

          {this.renderField({
            id: "register_password2",
            name: "password2",
            type: this.state.showPassword2 ? "text" : "password",
            labelKey: "password2",
            placeholderKey: "password2",
            icon: FaLock,
            hasError: error.password2,
            value: form.password2,
            showToggle: true,
            showValue: this.state.showPassword2,
            onToggle: this.togglePassword2,
          })}
          {error.password2 && (
            <p className="register-form__error">
              <Translate value={password2ErrorKey || "warning_password_similar"} />
            </p>
          )}

          <div className="register-form__field">
            <label className="register-form__label" htmlFor="register_country">
              <Translate value="choose_country" />
            </label>
            <div
              className={`register-form__input-wrap register-form__input-wrap--select${
                error.country_id ? " register-form__input-wrap--invalid" : ""
              }`}
            >
              <CountrySelect
                id="register_country"
                name="country_id"
                value={form.country_id || ""}
                countries={this.props.countryList}
                onChange={this.props.onChange}
                placeholder={I18n.t("choose_country")}
                hasError={error.country_id}
              />
            </div>
            {error.country_id && (
              <p className="register-form__error">
                <Translate value="warning_select_country" />
              </p>
            )}
          </div>

          <label className="register-form__tos">
            <input
              type="checkbox"
              className="register-form__tos-input"
              name="accept_tos"
              checked={accept_tos}
              onChange={onChangeAcceptTos}
            />
            <span className="register-form__tos-text">
              <Translate value="register_tos" />{" "}
              <Link to="/home/terms_condition" target="_blank" rel="noopener noreferrer">
                <Translate value="footer_tos" />
              </Link>{" "}
              <Translate value="and" />{" "}
              <Link to="/home/privacy_politics" target="_blank" rel="noopener noreferrer">
                <Translate value="footer_privacy" />
              </Link>
            </span>
          </label>

          <button
            type="submit"
            className="register-form__submit"
            disabled={submitting}
          >
            {submitting ? <MiniLoader /> : <Translate value="sign_in" />}
          </button>
        </form>

        <p className="register-card__login-link">
          <Translate value="password_forget_login" />{" "}
          <Link to="/login">
            <Translate value="login" />
          </Link>
        </p>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    countryList: reducer.country.list,
    error_country: reducer.country.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadCountry: () => dispatch(actions.loadList({})),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterForm));
